import { Observable, Subject } from "rxjs";
import { ProcessLine } from ".";

export interface MLCGraphObserverModel {
    mlcGraphObservable: Observable<MLCGraphData>;
    INTBStatusSubject: Subject<any>;
    TBCFStatusSubject: Subject<any>;
};

export interface MLCGraphWarningIndexGroupedData {
    [Key: string]: WarningIndexGraphSingleParamData;
};

export interface MLCGraphTrendsGroupedData {
    [Key: string]: GraphTrendsSingleParamData;
};

export interface MLCGraphData {
    MlcType: MLCGraphType;
    Timestamp?: string;
    Line: string | ProcessLine;
    [Key: string]: string | number;
};


export enum MLCGraphType {
    OVERVIEW = "OVERVIEW",
    WARNINGINDEX = "WARNINGINDEX",
    TRENDS = "TRENDS"
};

export enum WarningIndexGraphINTBSolution {
    BC_Application_Deviation = 'BC_Application_Deviation',
    BC_Quantity_Deviation = 'BC_Quantity_Deviation',
};

export interface WarningIndexGraphSingleParamData {
    Average: string;
    Average_Slope: string;
    CriteriaHigh: string;
    CriteriaLow: string;
    Std: string;
    Std_Slope: string;
    Target: string;
    Warning_Index: string | number;
    ParamName: string;
    Timestamp: string;
    MlcType: MLCGraphType.WARNINGINDEX;
    Line: string | ProcessLine;
    getTarget: boolean;
};

export interface GraphTrendsSingleParamData {
    Av1: string;
    Av2: string;
    Timestamp: string;
    MlcType: MLCGraphType.TRENDS;
    Line: string | ProcessLine;
};

export interface MLCGraphOverviewData extends MLCGraphData {
    MlcType: MLCGraphType.OVERVIEW;
};
export interface MLCGraphWarningIndexData extends MLCGraphData {
    MlcType: MLCGraphType.WARNINGINDEX;
};

export interface MLCGraphTrendsData extends MLCGraphData {
    MlcType: MLCGraphType.TRENDS;
};

export type GraphWIProcessFilter = (data?: MLCGraphWarningIndexData) => boolean;
export type MLCGraphDataEntries = [string, string | number][]
